import { goTo } from 'browser-history'
import { PageId } from 'page-constants'
import { AppName, SUPPORT_FORM_LINKS } from 'root-constants'

export const useContactFormNavigation = () => {
  const goToContactForm = (appName?: string) => {
    if (appName === AppName.DEEPLY) {
      window.location.assign(SUPPORT_FORM_LINKS[AppName.DEEPLY])
      return
    }

    goTo(PageId.CONTACT_FORM)
  }

  return { goToContactForm }
}
